import React, { useEffect, useState, useRef, useContext } from 'react';
import { Toast } from 'primereact/toast';
import Form from 'react-bootstrap/Form';
import { BreadCrumb } from 'primereact/breadcrumb';
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
// import MapIcon from '../../assets/icons/map.svg';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import MapComponent from '../MapComponent';
import { getNotification, payment, getCustomerDebt, GetAllOrders } from '../../utils/api';
import moment from 'jalali-moment';
import Loadr from '../loader/loader';
import LoaderPage from '../loader/dotloader';
import useToastNotification from '../../hooks/useToastNotification';
import UploadIcon from '../../assets/icons/ticket/upload.svg';
import { Accordion, AccordionTab } from 'primereact/accordion';

import Loader from '../loader/loader'
//icon
import Factor from '../../assets/icons/order/factor.svg';
import Calendar from '../../assets/icons/order/calendar.svg';
import Clipboard from '../../assets/icons/order/clipboard.svg';
import Shop from '../../assets/icons/order/shop.svg';
import TextBox from '../../assets/icons/order/textBox.svg';
import Wallet from '../../assets/icons/payment/wallet.svg'
import Receipt from '../../assets/icons/payment/receipt.svg'
import User from '../../assets/icons/payment/user.svg'
import Cards from '../../assets/icons/order/cards.svg';


function Profile() { // Receive onProfileLoad as a prop
    const [loading, setLoading] = useState(false);
    const [paymentData, setPaymentDate] = useState(null);
    const [orderData, setOrderData] = useState([]);
    const [paymentAmount, setPaymentAmount] = useState('');
    const [paymentAccount, setPaymentAccount] = useState('');
    const [trackingNumber, setTrackingNumber] = useState('');
    const [paymentDateList, setPaymentDateList] = useState(null);
    const [description, setDescription] = useState('');
    const [validated, setValidated] = useState(false)
    const [file, setFile] = useState(null);
    const { showError, showSuccess } = useToastNotification();
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        let customerDatares = window.localStorage.getItem('userInfo');
        let fd = new Date();
        fd.setMonth(fd.getMonth() - 12);
        let fromDateNew = fd;

        let pay = {
            fromDate: convertDateToPersian(fromDateNew),
            toDate: convertDateToPersian(new Date()),
            userId: JSON.parse(customerDatares).si,
            factorNum: '',
            status: ''
        };

        ordersData(pay);
    }, []);
    const ordersData = async (pay) => {
        try {
            let res = await GetAllOrders(pay);
            if (res.status === 200) {
                // فیلتر کردن داده‌ها بر اساس شرایط
                const filteredData = res.data.filter(order => order.Acc === "A" && order.Sit === "C");
                setOrderData(filteredData);
            }
        } catch (error) {
            console.error("خطا در دریافت سفارشات:", error);
        } finally {
        }
    };


    const fetchDebt = async () => {
        try {
            let res = await getCustomerDebt(JSON.parse(localStorage.getItem('userInfo')).si)
            if (res.status == 200) {
                setPaymentAmount(res.data[0].Bedehi)
                setPaymentDateList(res.data[0])
                console.log(res.data)
            } else {
                let error = {
                    title: 'اخطار',
                    text: response.data.restp,
                };
                showError(error);
            }
        } catch (error) {

            showError('خطا در برقرای ارتباط ...');
        }
    }

    useEffect(() => {
        fetchDebt()
    }, [])



    const convertDateToPersian = (date) => {
        if (!date) return '-';
        return moment(date).locale("fa").format("YYYY/MM/DD");
    };
    const [filePreview, setFilePreview] = useState(null);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);

        if (selectedFile && selectedFile.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setFilePreview(reader.result); // base64 image preview
            };
            reader.readAsDataURL(selectedFile);
        } else {
            setFilePreview(null);
        }
    };

    const handleFileClick = () => {
        document.getElementById('file-upload').click();
    };
    function convertToPersianNumbers(input) {
        if (input) {

            const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
            return input.replace(/\d/g, (digit) => persianDigits[digit]);
        }
    }
    const convertFileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onloadend = () => {
                const base64String = reader.result;
                const extension = file.name.split('.').pop().toLowerCase();

                resolve({
                    base64: base64String,
                    extension: extension,
                });
            };

            reader.onerror = (error) => {
                reject(error);
            };

            reader.readAsDataURL(file);
        });
    };
    const formatAmount = (value) => {
        if (!value) return '';
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, ','); // Add commas as thousand separators
    };

    const handleAmountChange = (input) => {
        const rawValue = input.replace(/,/g, ''); // Remove existing commas
        if (/^\d*$/.test(rawValue)) { // Ensure the value is numeric
            setPaymentAmount(rawValue);
        }
    };
    const uploadForm = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === true) {
            event.stopPropagation();
            try {
                if (!paymentData || paymentData == '') {
                    showError('لطفا تاریخ پرداخت را وارد کنید.')
                    return
                }
                let base64 = "";
                let extension = "";
                if (file) {
                    const result = await convertFileToBase64(file);
                    base64 = result.base64;
                    extension = result.extension;
                } else {
                    showError('لطفا فیش پرداختی را اپلود کنید.')
                    return
                }
                setLoader(true);

                let pay = {
                    userId: (JSON.parse(window.localStorage.getItem('userInfo')).si).toString(),
                    date: paymentData,
                    orderId: '',
                    cash:  paymentAmount.toString().replace(/,/g, ''),
                    peygiri: trackingNumber,
                    hesab: paymentAccount,
                    sharh: description,
                    type: extension,  // پسوند فایل
                    image: base64
                }
                let response = await payment(pay);

                if (response.data.res === 'OK') {

                    setLoader(false)
                    showSuccess(response.data.restp);
                    setPaymentDate(null)
                    setPaymentAmount('')
                    setPaymentAccount('')
                    setTrackingNumber('')
                    setDescription('')
                    setFile(null)
                    setValidated(false)

                } else if (response.data.res === 'NotOk') {
                    setLoader(false);

                    let error = {
                        title: 'اخطار',
                        text: response.data.restp,
                    };
                    showError(error);
                }
            } catch (error) {
                setLoader(false);
                console.log(error);
                showError('خطا در برقراری ارتباط...');
            }
        }

        setValidated(true);
    }
    const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"]


    return (
        <>
            {loading && <LoaderPage isLoading={loading} />}

            <div className='profile-card'>
                <h6 className='page-title mb-4 mt-3'>پرداخت</h6>
                <div className='ticket-box'>
                    <Accordion activeIndex={0}>
                        <AccordionTab header='اطلاعات حساب بن آیس'>

                            <div>
                                <div className='row gy-4 mt-1'>
                                    <div className='col-md-4 col-lg-3 col-sm-12 d-flex align-items-center gap-2'>
                                        <img src={Wallet} alt="" />
                                        <h6 className='m-0 f-14 '>شماره حساب : {convertToPersianNumbers(paymentDateList?.NuKart)}</h6>
                                    </div>
                                    <div className='col-md-4 col-lg-3 col-sm-12 d-flex align-items-center gap-2'>
                                        <img src={User} alt="" />
                                        <h6 className='m-0 f-14 '>نام دارنده حساب: {paymentDateList?.MalekHesab}</h6>
                                    </div>
                                    <div className='col-md-4 col-lg-3 col-sm-12 d-flex align-items-center gap-2'>
                                        <img src={Receipt} alt="" />
                                        <h6 className='m-0 f-14 '>شماره شبا : {convertToPersianNumbers(paymentDateList?.NuShaba)}</h6>
                                    </div>
                                    <div className='col-md-4 col-lg-3 col-sm-12 d-flex align-items-center gap-2'>
                                        <img src={Cards} alt="" />
                                        <h6 className='m-0 f-14 number-font'>مبلغ بدهی: {paymentDateList?.Bedehi} تومان</h6>
                                    </div>
                                </div>

                            </div>


                        </AccordionTab>
                    </Accordion>
                </div>



                <div className='ticket-box mt-2'>
                    <Accordion activeIndex={1}>
                        <AccordionTab header='فاکتور های دارای بدهی'>
                            <>

                                {(!!orderData && orderData.length > 0) && orderData.map((order, index, array) =>
                                    <div className=' ' >
                                        <div className='row gy-4 mt-2' key={order.Si}>
                                            <div className='col-md-4 col-lg-3 col-sm-12 d-flex align-items-center gap-2'>
                                                <img src={Factor} alt="" />
                                                <h6 className='m-0 f-14 '>شماره سفارش: {convertToPersianNumbers((order.Num).toString())}</h6>
                                            </div>
                                            <div className='col-md-4 col-lg-3 col-sm-12 d-flex align-items-center gap-2'>
                                                <img src={Calendar} alt="" />
                                                <h6 className='m-0 f-14 '>تاریخ ثبت سفارش: {convertToPersianNumbers(order.DateSabt)}</h6>
                                            </div>
                                            <div className='col-md-4 col-lg-3 col-sm-12 d-flex align-items-center gap-2'>
                                                <img src={Calendar} alt="" />
                                                <h6 className='m-0 f-14 '> تاریخ تحویل: {convertToPersianNumbers(order.DateTahvil)}</h6>
                                            </div>

                                            <div className='col-md-4 col-lg-3 col-sm-12 d-flex align-items-center gap-2'>
                                                <img src={Cards} alt="" />
                                                <h6 className='m-0 f-14 number-font'>مبلغ: {parseInt((order.Payment).toString()).toLocaleString()} تومان</h6>
                                            </div>
                                            <div className='col-md-4 col-lg-3 col-sm-12 d-flex align-items-center gap-2'>
                                                <img src={Clipboard} alt="" />
                                                <h6 className='m-0 f-14 d-flex align-items-center gap-1' >وضعیت: <h6 className='m-0 f-14' style={{
                                                    color: order.Sit === 'A' ? 'blue' :
                                                        order.Sit === 'B' ? 'red' :
                                                            order.Sit === 'C' ? 'green' : '#f8a300'
                                                }}>
                                                    {order.SitTp} </h6> </h6>
                                            </div>


                                        </div>
                                        {index < array.length - 1 && <hr className="dashed-2" />}
                                    </div>
                                )}
                            </>

                        </AccordionTab>
                    </Accordion>
                </div>
                <Form className='row gy-2 mt-3' noValidate validated={validated} onSubmit={(e) => uploadForm(e)}>
                    <Form.Group className="col-sm-12 col-md-6 col-lg-4 ">
                        <Form.Label>تاریخ پرداخت <span className='text-[red]'> * </span></Form.Label>
                        <DatePicker
                            weekDays={weekDays}
                            value={paymentData}
                            onChange={(date) => setPaymentDate(convertDateToPersian(date.toDate()))}
                            calendar={persian}
                            locale={persian_fa}

                        />
                    </Form.Group>
                    <Form.Group className="col-sm-12 col-md-6 col-lg-4">
                        <Form.Label>مبلغ <span className='text-[red]'> * </span></Form.Label>
                        <div className=''>
                            <Form.Control className='number-font' required type="text" value={formatAmount(paymentAmount)} // Apply formatting to the displayed value
                                onChange={(e) => handleAmountChange(e.target.value)} />

                            <Form.Control.Feedback type="invalid">
                                مبلغ را وارد کنید.
                            </Form.Control.Feedback>
                        </div>
                    </Form.Group>
                    <Form.Group className="col-sm-12 col-md-6 col-lg-4">
                        <Form.Label>شماره حساب <span className='text-[red]'> * </span></Form.Label>
                        <div className=''>
                            <Form.Control required type="number" value={paymentAccount} onChange={(e) => setPaymentAccount(e.target.value)} />

                            <Form.Control.Feedback type="invalid">
                                شماره حساب را وارد کنید.
                            </Form.Control.Feedback>
                        </div>
                    </Form.Group>
                    <Form.Group className="col-sm-12 col-md-6 col-lg-4">
                        <Form.Label>شماره پیگیری <span className='text-[red]'> * </span></Form.Label>
                        <div className=''>
                            <Form.Control required type="number" value={trackingNumber} onChange={(e) => setTrackingNumber(e.target.value)} />

                            <Form.Control.Feedback type="invalid">
                                شماره پیگیری را وارد کنید.
                            </Form.Control.Feedback>
                        </div>
                    </Form.Group>
                    <Form.Group className="col-sm-12 col-md-6 col-lg-8">
                        <Form.Label>توضیحات </Form.Label>
                        <div className=''>
                            <Form.Control as="textarea" type="text" value={description} onChange={(e) => setDescription(e.target.value)} />


                        </div>
                    </Form.Group>



                    <div className=''>
                        <h6 className='my-4 text-right'>رسید پرداخت را آپلود کنید.</h6>
                        <div className="file-upload-container" onClick={handleFileClick}>
                            <input type="file" onChange={handleFileChange} id="file-upload" style={{ display: 'none' }} accept=".jpg,.jpeg,.png,.pdf" />
                            <img src={UploadIcon} alt="Upload Icon" />
                            <h6 className='text-xs font-medium mt-2'>
                                {file ? file.name : 'رسید پرداخت را از این قسمت وارد کنید.'}
                            </h6>
                        </div>
                        {filePreview && (
                        <div className=' '>
                            <img src={filePreview} alt="Preview" className="img-preview mt-2 aspect-[4/4] rounded-lg" width={150}  />
                        </div>
                    )}
                        <div className='d-flex justify-content-end'>

                            <button type='submit' className='btn btn-primary  mt-5 '>ارسال جهت بررسی {loader && <Loader />}</button>
                        </div>

                    </div>  </Form>
            </div>
        </>
    );
}

export default Profile;
